import { displayKey } from "@citrine/resources/descriptor";

type DescriptorKeyProps =
  | {
      descriptor: { descriptor_key: string };
      descriptorKey?: never;
    }
  | {
      descriptor?: never;
      descriptorKey: string;
    };

/**
 * Simpler wrapper component for rendering descriptor keys that replaces the `~`
 * character with `:`.
 * Accepts either a `descriptorKey` or `descriptor`.
 */
export function DescriptorKey({
  descriptor,
  descriptorKey,
}: DescriptorKeyProps) {
  return <>{displayKey(descriptorKey ?? descriptor?.descriptor_key ?? "")}</>;
}
